import React from "react";
import Sidebar from "../../../components/Sidebar";
import AISkillsLearning from "./AISkillsLearning";
import { Outlet, useLocation } from "react-router-dom";

const AISkillsLearningPage = () => {
  const location = useLocation();
  
  return (
    <Sidebar>
      {location.pathname === "/dashboard/ai-skills-learning" && (
        <AISkillsLearning />
      )}
      <Outlet />
    </Sidebar>
  );
};

export default AISkillsLearningPage; 